<template>
  <div v-show="isLoaded" class="mMobileCampaign-container" v-observe-visibility="startAnimate">
    <!-- <h3 class="mSection-title" :class="{onlySafari: isSafari}">Cerveza Indio, Como el Rock, <span>Incontenible</span></h3> -->
    <h3 class="mSection-title" :class="{onlySafari: isSafari}"></h3>
    <p class="mText-1" :class="{onlySafari: isSafari}">En nuestra historia hemos enfrentado diferentes batallas pero cuando las compartimos, </p>
    <p class="mText-2" :class="{onlySafari: isSafari}"> seguimos adelante como los guerreros y guerreras que somos. <span>Indio #DeAlmaGuerrera</span> </p>
    <div class="incontenible" :class="{onlySafari: isSafari}">
     <div id="player"></div>
    </div>
    <!--<div class="Banner-container">
      <a href="https://promocerveza.mx/indio-tecate/">
        <img class="desktop" :class="{onlySafari: isSafari}" :src="banner_desktop" alt="Banner-desktop">
        <img class="mobile" :src="banner_mobile" alt="Banner-mobile">
      </a>
    </div>-->
    <!-- <div class="Banner-vive2024">
      <a href="https://indio.com.mx/vlindio24/">
        <img class="desktop_vive" :class="{onlySafari: isSafari}" :src="banner_vive" alt="Banner vive latino 2024">
      </a>
    </div> -->
    
    <!-- <p class="mText-3">
      Y de esta gran fusión, solo podía nacer una gran cerveza.
    </p> -->
    <!-- <img class="incontenible" :src="incontenible" alt="Incontenible"> -->
    
    <div class="green-bar left" :class="{animate: animate}"></div>
    <div class="green-bar right" :class="{animate: animate}"></div>
  </div>
</template>

<script>
import incontenible from "@/assets/BANNER PROVISIONAL.jpg";
import banner_desktop from "@/assets/banner_desktop_dorada.jpg";
import banner_mobile from "@/assets/banner_mobile_dorada.jpg";
import banner_vive from "@/assets/banner_vive.png";
import tagFunctions from "@/utils/tagFunctions.js";
import YouTubePlayer from 'youtube-player';
import { mapGetters } from "vuex";
import Bowser from "bowser"; 

let timer, percent = 0, quartileTime
export default {
  name: "MobileCampaign",
  data() {
    return {
      incontenible,
      banner_desktop,
      banner_mobile,
      banner_vive,
      player: null,
      animate: false,
      isSafari: false
    };
  },
      computed: {
    ...mapGetters(["isLoaded"]),
  },

  methods: {
    startAnimate(isVisible){
      if(isVisible){
      this.animate=true;
      }
      
    },
    record(event) {
      let currentTime = Math.round(event.target.getCurrentTime());
      percent = getPercent(event);

      if (currentTime == quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "25"
        );
      }

      if (currentTime == 2 * quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "50"
        );
      }
      if (currentTime == 3 * quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "75"
        );
      }

      if (currentTime == Math.round(event.target.getDuration() * 0.99)) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "100"
        );
      }

      function getPercent(event) {
        return Math.round(
          (event.target.getCurrentTime() / event.target.getDuration()) * 100
        );
      }
    },
    onPlayerStateChange(event) {
      quartileTime = Math.round(event.target.getDuration() / 4);
      const getQuartile = () => {
        if (percent <= 25) return 25;
        else if (percent > 25 && percent <= 50) return 50;
        else if (percent > 50 && percent <= 75) return 75;
        else return 100;
      };

      if (event.data == window.YT.PlayerState.PLAYING) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Play", getQuartile())
        
        timer = setInterval(() => {
          this.record(event);
        }, 1000);
      } else {
        clearInterval(timer);
      }

      if (event.data == window.YT.PlayerState.ENDED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Complete", getQuartile())
        
      }

      if (event.data == window.YT.PlayerState.PAUSED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Pause", getQuartile())
        
      }
    },
    // getCleanVideoId(rawId) {
    //   // Elimina cualquier parámetro adicional como ?si=...
    //   const cleanId = rawId.split('?')[0];
    //   return cleanId.length === 11 ? cleanId : null;
    // }
  },
  mounted() {
    // const rawVideoId = '2AFTcwLfmvs?si=Ir2PiEsFcbUn6jnu'; // si lo estás obteniendo dinámicamente, reemplaza esto
    // const videoId = this.getCleanVideoId(rawVideoId);
    // if (videoId) {
    //   this.player = YouTubePlayer('player', {videoId: videoId, width: '100%', height: '85%'});
    //   this.player.on('stateChange', this.onPlayerStateChange);
    // } else {
    //   console.error('Video ID inválido:', rawVideoId);
    // }
    // console.log('Video ID limpio:', videoId);
    this.player = YouTubePlayer('player', {videoId: 'PhemVCkivsM', width: '100%', height:'85%'})
    this.player.on('stateChange', this.onPlayerStateChange)
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/MobileCampaign.scss";
</style>
